export default "__VITE_ASSET__0f055db0__"